import superagent from 'superagent';

export const csvbundleUploader = (data, callback, token, onProgress) => {
    let gotDone = false;
    let lineBuffer = '';   // accumulates text across onprogress chunks
    let processedLength = 0;

    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/lm/v1/csvbundle_uploader', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (token) xhr.setRequestHeader('Authorization', 'Bearer ' + token);
    xhr.withCredentials = true;
    xhr.timeout = 600000;

    // Process complete SSE lines from the buffer.
    // Accumulates partial lines so a JSON split across two chunks is handled correctly.
    const processLines = (newText) => {
        if (gotDone) return;
        lineBuffer += newText;

        let nlIdx;
        while ((nlIdx = lineBuffer.indexOf('\n')) !== -1) {
            const line = lineBuffer.slice(0, nlIdx).trim();
            lineBuffer = lineBuffer.slice(nlIdx + 1);

            if (!line.startsWith('data:')) continue;
            const jsonStr = line.slice(5).trim();
            try {
                const parsed = JSON.parse(jsonStr);
                if (parsed.done) {
                    gotDone = true;
                    callback(parsed.status === 'success', parsed);
                    return;
                } else if (onProgress && typeof parsed.progress === 'number') {
                    onProgress(parsed.progress, parsed.processed, parsed.total);
                }
            } catch (e) {}
        }
    };

    xhr.onprogress = () => {
        const newText = xhr.responseText.slice(processedLength);
        processedLength = xhr.responseText.length;
        processLines(newText);
    };

    xhr.onload = () => {
        if (!gotDone) {
            // Drain any text not yet consumed by onprogress
            processLines(xhr.responseText.slice(processedLength));
            if (!gotDone) {
                // Last resort: try the full response as plain JSON
                try {
                    const parsed = JSON.parse(xhr.responseText.trim());
                    callback(parsed.status === 'success', parsed);
                } catch (e) {
                    callback(false, { message: 'Invalid response from server' });
                }
            }
        }
    };

    xhr.onerror = () => callback(false, { message: 'Network error' });
    xhr.ontimeout = () => callback(false, { message: 'Request timed out' });

    xhr.send(JSON.stringify(data));
};


export const preview = (auth_body, callback) => {
    console.log(URL, "heck yeah");

    superagent.post(URL + '/preview')
        .send(auth_body)
        .end((err, response) => {
            if (err) {
                callback(false);
                console.log('Request failed')
            } else {
                if (response.status === 200) {
                    callback(true)
                } else {
                    callback(false)
                }
            }
        });
};

